/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SafetyDto } from '../../models/safety-dto';

export interface UpdateSafety$Params {

/**
 * safetyId
 */
  id: number;
      body: SafetyDto
}

export function updateSafety(http: HttpClient, rootUrl: string, params: UpdateSafety$Params, context?: HttpContext): Observable<StrictHttpResponse<SafetyDto>> {
  const rb = new RequestBuilder(rootUrl, updateSafety.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SafetyDto>;
    })
  );
}

updateSafety.PATH = '/safeties/{id}';
